/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */




/* Infinite Product Options カート画面で小数点削除 */

  $( document ).ready(function() {
   setTimeout(function(){ 
    $(".CartItem__PropertyList .CartItem__Property").each(function(){
     console.log("test console..");
      var a =  $(this).html();
	//	console.log("console..value", a);
      var b = $(this).html($(this).html().replace(".00",""));
      console.log("..value..", b);
      $(this).html($(this).text().replace(".00",""));
    });
 
     }, 3000);
  });




/* スクロールでフィードイン */

$(function(){
  function animation(){
    $('.fadeInUp').each(function(){
      //ターゲットの位置を取得
      var target = $(this).offset().top;
      //スクロール量を取得
      var scroll = $(window).scrollTop();
      //ウィンドウの高さを取得
      var windowHeight = $(window).height();
      //ターゲットまでスクロールするとフェードインする
      if (scroll > target - windowHeight){
        $(this).css('opacity','1');
        $(this).css('transform','translateY(0)');
      }
    });
  }
  animation();
  $(window).scroll(function (){
    animation();
  });
});






/* ニュースリンク（ロールオーバーで画像表示）*/

jQuery(function($){
  if (window.matchMedia( "(min-width: 768px)" ).matches) {
    $('.compornentbox-blog-link ol li').mousemove(function (event) {

      var x = event.offsetX ;
      var y = event.offsetY ;
      var iti = "translate(" + x + "px," + y + "px)";      

      $('.compornentbox-blog-link ol li .img').css('transform',iti);

      $('.compornentbox-blog-link ol li').mouseover(function () {
        var target = $(this).data("index");        
        $(this).children(".img").addClass('is-show');

      }).mouseout(function() {

        var target = $(this).data("index");
        $(this).children(".img").removeClass('is-show');

      });

    });
  }
});


/* TOP特集画像スライダー_NEWS */

jQuery(function($){
  $('.shopify-section-news .blog-feed-area .slider').each(function(){
    $(this).slick({
      autoplay:false,
      autoplaySpeed:5000,
      arrows: true,
      slidesToShow: 4,
      slidesToScroll: 1,
      dots:false,
      responsive:[
        {
          breakpoint: 768,
          settings:{
            slidesToShow: 2,
          }
        },         
      ]
    });
  });	
});	


/* TOP特集画像スライダー_特集 */

jQuery(function($){
  $('.shopify-section-feature .slider').each(function(){
    // $(this).slick({
      var $slider = $(this);
      var perView = $slider.data('colonial-slick') || 4; // デフォルト4、colonial-slickのデータがある場合6
      $slider.slick({
      autoplay:false,
      autoplaySpeed:5000,
      arrows: true,
      slidesToShow: perView,
      slidesToScroll: 1,
      dots:false,
      responsive:[
        {
          breakpoint: 768,
          settings:{
            slidesToShow: 2,
          }
        },         
      ]
    });
  });	
  });


/* TOP特集画像スライダー_STORE */
jQuery(function($){
  $('.shopify-section-feature-store .midashi-area .slider').each(function(){
    $(this).slick({
      autoplay:false,
      autoplaySpeed:5000,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots:false,
      responsive:[
        {
          breakpoint: 768,
          settings:{
            slidesToShow: 2,
          }
        },         
      ]
    });
  });	
  });	



/*- 画像スライダー(TOP) */
jQuery(function($){
  $('.shopify-section-text-withimage .img-area .slider').each(function(){
    $(this).slick({
      autoplay:false,
      autoplaySpeed:5000,
      arrows: true,        
      dots:true,
      responsive:[          
        {
          breakpoint: 768,
          settings:{
            dots:false,
          }
        },         
      ]
    });
  });	
});	




/* 画像スライダー(コレクションページ) */
jQuery(function($){
  $('.articlebox-collection-imgslider .slider').each(function(){
    $(this).slick({
      autoplay:false,
      autoplaySpeed:5000,
      arrows: true,        
      dots:true        
    });
  });	
});	


  
/* コーディネート画像スライダー(コレクションページ) */

jQuery(function($){
  $('.articlebox-collection-coordination .slider').each(function(){
    $(this).slick({
      autoplay:false,
      autoplaySpeed:5000,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots:true,
      responsive:[          
        {
          breakpoint: 768,
          settings:{
            slidesToShow: 1,
          }
        },
      ]
    });
  });	
});	


  
/* ジャーナルスライダー(コレクションページ) */

jQuery(function($){
  if (window.matchMedia( "(min-width: 768px)" ).matches) {
    $('.articlebox-collection-journal .slider').each(function(){
      $(this).slick({
        autoplay:false,
        autoplaySpeed:5000,
        arrows: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots:false,
        responsive:[          
          {
            breakpoint: 769,
            settings:{
              slidesToShow: 2,
            }
          },
        ]
      });
    });	
  }    
});	


/* ブログサイドバー_アコーディオン */
$(function(){
  if (window.matchMedia( "(max-width: 1000px)" ).matches) {
    $(".section-blog-content aside .item .tit").on("click", function() {    
      $(this).next().slideToggle();
    });
  }
});


/* Yチェアコレクションページ専用スライダー */

jQuery(function($){
  $('.shopify-section-feature .slider-2').each(function(){
    $(this).slick({
      autoplay:false,
      autoplaySpeed:5000,
      arrows: true,
      slidesToShow: 2,
      slidesToScroll: 1,
      dots:false,
      responsive:[
        {
          breakpoint: 768,
          settings:{
            slidesToShow: 1,
          }
        },         
      ]
    });
  });	
});	